module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gGK67"))).then(() => parcelRequire('ljYL6'));